import { Injectable } from '@angular/core';
import { ITipoPista } from '../models/pista';
import { IS1SearchParams, S1ApiCrudService, S1HttpClientService } from '@app/s1';

export interface IRicercaTipoPistaParams extends IS1SearchParams, Partial<ITipoPista> { }

@Injectable({
  providedIn: 'root'
})
export class TipoPistaService extends S1ApiCrudService<ITipoPista, IRicercaTipoPistaParams> {

  constructor(s1HttpClient: S1HttpClientService) { 
    super(s1HttpClient, "/tipoPista");
  }

}